/**
 * Cookie Consent — Componente UI per il banner e il pannello preferenze.
 *
 * Tutta la logica è in $store.consent. Questo componente gestisce solo la UI.
 */
export function registerCookieConsent(Alpine) {
    Alpine.data('cookieConsent', () => ({
        get visible()   { return Alpine.store('consent').bannerVisible; },
        get prefsOpen() { return Alpine.store('consent').preferencesOpen; },
        get analytics() { return Alpine.store('consent').categories.analytics; },
        set analytics(v) { Alpine.store('consent').categories.analytics = v; },
        get marketing() { return Alpine.store('consent').categories.marketing; },
        set marketing(v) { Alpine.store('consent').categories.marketing = v; },

        acceptAll()          { Alpine.store('consent').acceptAll(); },
        rejectNonEssential() { Alpine.store('consent').rejectNonEssential(); },
        openPreferences()    { Alpine.store('consent').openPreferences(); },
        closePreferences()   { Alpine.store('consent').closePreferences(); },
        savePreferences()    { Alpine.store('consent').savePreferences(); },
    }));
}
